import React, { Component } from "react";

class IconButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentImg: props.image
        };
    };

    changeImage = image => {
        this.setState({
            currentImg: image
        })
    };

    render() {
        const {
            image = "",
            invertedImage = "",
            selected = false,
            handleIconClick = () => {},
            classes = "",
            alt = "img",
            disabled = false,
            textMode = false,
        } = this.props;

        const {
            currentImg
        } = this.state;

        return textMode ?
            <button
                className={"hover-pointer " + (disabled ? "disabled " : "") + classes}
                onClick={disabled ? null : handleIconClick}
            >
                {alt}
            </button> :
            <img
                alt={alt}
                src={selected && invertedImage ? invertedImage : currentImg}
                className={"hover-pointer " + (disabled ? "disabled " : "") + classes}
                onClick={ (e) => {
                    if(!disabled) {
                        handleIconClick(e);
                    }
                }}
                onMouseEnter={() => {
                    if(!disabled) {
                        this.changeImage(invertedImage ? invertedImage : currentImg);
                    }
                }}
                onMouseOut={() => {
                    if(!disabled) {
                        this.changeImage(image);
                    }
                }}
            />
    }
}

export default IconButton;